"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showManualPageValueModal = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var CurrencyInput_1 = __importDefault(require("@CommonFrontend/CurrencyInput/CurrencyInput"));
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var CurrencySelector_1 = require("./CurrencySelector");
function showManualPageValueModal(modal, projectStore, pageQuoteTotalStore) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, modal.showAcknowledgeModal({
                        header: react_1.default.createElement(ModalContent, { key: "1", projectStore: projectStore, pageQuoteTotalStore: pageQuoteTotalStore }),
                        buttonLabel: "Done",
                        isEscapable: true,
                    })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.showManualPageValueModal = showManualPageValueModal;
var c = (0, BemBuilder_1.default)("manual-page-value-modal");
var ModalContent = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var pageQuoteTotalStore = _a.pageQuoteTotalStore, projectStore = _a.projectStore;
    var hasQuoteCurrency = pageQuoteTotalStore.hasQuoteCurrency;
    var pageCurrency = pageQuoteTotalStore.getCurrency(true);
    var pageCurrencyLocale = pageQuoteTotalStore.getCurrencyLocale();
    var currencySelectorDisabled = hasQuoteCurrency;
    function toggleManualPageValue(enabled) {
        var manualPageValue = __assign({}, projectStore.manualPageValue);
        if (enabled) {
            manualPageValue.currency = pageCurrency !== null && pageCurrency !== void 0 ? pageCurrency : "AUD";
            manualPageValue.value = hasQuoteCurrency ? pageQuoteTotalStore.getTotal(false) : 0;
        }
        else {
            delete manualPageValue.currency;
            delete manualPageValue.value;
        }
        projectStore.setManualPageValue(__assign(__assign({}, manualPageValue), { enabled: enabled }));
    }
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(kaleidoscope_1.Heading, { className: "space-stack-m", level: "3", strong: true }, "Page value"),
        react_1.default.createElement("div", { className: "space-stack-l" },
            react_1.default.createElement(kaleidoscope_1.Text, null, "Set a page value for reporting. Once the page is accepted the value cannot be changed, and will be overriden by the quote value (if a quote block exists).")),
        react_1.default.createElement("div", { className: "".concat(c("quote-value"), " space-stack-l") },
            react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, "Quote value"),
            react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, (_b = pageQuoteTotalStore.formattedQuoteValue) !== null && _b !== void 0 ? _b : "n/a")),
        react_1.default.createElement("div", { className: "space-stack-s" },
            react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Set page value", value: projectStore.manualPageValue.enabled, onChange: toggleManualPageValue })),
        projectStore.manualPageValue.enabled && (react_1.default.createElement("div", { className: c("inputs-section") },
            react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () { return (react_1.default.createElement(CurrencySelector_1.CurrencySelector, { currentCurrency: pageCurrency, onChange: function (currency) {
                    return projectStore.setManualPageValue(__assign(__assign({}, projectStore.manualPageValue), { currency: currency }));
                }, disabled: currencySelectorDisabled, tooltipProps: currencySelectorDisabled
                    ? {
                        content: "Use the quote block to change the currency for this page",
                        size: kaleidoscope_1.TooltipSize.Large,
                        position: kaleidoscope_1.TooltipPosition.Bottom,
                        wrapTarget: true,
                    }
                    : undefined })); }),
            react_1.default.createElement(CurrencyInput_1.default, { className: c("currency-value-input"), value: projectStore.manualPageValue.value, label: "Page value", labelHidden: true, onChange: function (value) { return projectStore.setManualPageValue(__assign(__assign({}, projectStore.manualPageValue), { value: value })); }, formatCurrency: function (value) { return (0, FormatCurrency_1.formatCurrency)(value, pageCurrency, undefined, pageCurrencyLocale); }, parseCurrency: function (value) {
                    return (0, FormatCurrency_1.parseCurrency)(value, pageCurrency, { locale: pageCurrencyLocale });
                } })))));
});
